module.exports = __webpack_public_path__ + "static/StackSports-2610fa63eb402257826d5a7409a82c49.jpg";